<style lang="scss">

</style>

<!-- eslint-disable -->
<template>
  <div class="mt-2">
    <div v-if="groupedData.length > 0">
      <div class="row mt-3" v-for="(data, index) in groupedData" :key="index">
        <div class="col-12">
          <h2 v-if="prison.enable_wings"><b>{{data.wingName ? data.wingName + ' -' : ''}} {{getTerminalsRequiredForWing(index)}} {{getTerminalsRequiredForWing(index) === 1 ? 'Terminal' : 'Terminals'}} Required</b></h2>
          <div class="row" v-for="(bookingSlots, bookingSlotIndex) in data.bookingSlots" :key="`${index}-${bookingSlotIndex}`">
            <div class="col-12">
              <h3><b>{{bookingSlots.bookingSlotName}}</b></h3>
              <p v-for="(visitsInfo, visitInfoIndex) in bookingSlots.visitInfo" :key="`${visitInfoIndex}-${bookingSlotIndex}-${index}`">{{visitsInfo}}</p>
            </div>
          </div>
          <div class="row" v-if="prison.allow_kiosk && data.kioskItems.length > 0">
            <div class="col-12">
              <h4><b>Kiosk Items</b></h4>
              <p>{{getKioskItemsText(data.kioskItems)}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>No calls approved for this date.</p>
    </div>
  </div>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import { getAdditionalVisitorsTextForBookingSlot, getKioskItemsText } from '@/util/PrintHelpers';

export default {
  components: {},
  props: {
    calls: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      groupedData: [],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
    }),
  },
  watch: {
    calls() {
      this.groupData();
    },
  },
  mounted() {
    this.groupData();
  },
  methods: {
    getKioskItemsText: getKioskItemsText,
    groupData() {
      // Filter out visits that are not approved
      const approvedVisits = this.calls.filter(visit => visit.status === 'Approved');
      // Get all wings
      // {
      // wingId: string,
      // wingName: string
      // bookingSlots: [{
      //  bookingSlotId
      //  bookingSlotName
      //  visitInfo: string[]
      // }]
      // }
      const wings = [];
      approvedVisits.forEach(visit => {
        // Check if it is included already
        let wingExists = false;
        let wingIndex = -1;
        wings.forEach((wing, index) => {
          if (visit.booked_slot.wing_id && wing.wingId === visit.booked_slot.wing_id) {
            wingExists = true;
            wingIndex = index;
          }
        });

        if (!wingExists) {
          // Add wing
          wings.push({
            wingId: visit.booked_slot.wing_id,
            wingName: visit.booked_slot.wing_name,
            bookingSlots: [{
              bookingSlotId: visit.booked_slot.booking_slot_id,
              bookingSlotName: `Booking slot ${visit.booked_slot.slot_begin} - ${visit.booked_slot.slot_end}`,
              visitInfo: [`${visit.prisoner.firstname} ${visit.prisoner.lastname} ${visit.prisoner.prisoner_number} - ${visit.visitor.firstname} ${visit.visitor.lastname} ${getAdditionalVisitorsTextForBookingSlot(visit.additional_visitors)}`],
            }],
            kioskItems: visit.kiosk_items || [],
          });
        } else {
          // Check if the booking slot exists
          let bookingSlotExists = false;
          let bookingSlotIndex = -1;
          wings[wingIndex].bookingSlots.forEach((bookingSlot, index) => {
            if (bookingSlot.bookingSlotId === visit.booked_slot.booking_slot_id) {
              bookingSlotExists = true;
              bookingSlotIndex = index;
            }
          });
          if (!bookingSlotExists) {
            // Add booking slot
            wings[wingIndex].bookingSlots.push({
              bookingSlotId: visit.booked_slot.booking_slot_id,
              bookingSlotName: `Booking slot ${visit.booked_slot.slot_begin} - ${visit.booked_slot.slot_end}`,
              visitInfo: [`${visit.prisoner.firstname} ${visit.prisoner.lastname} ${visit.prisoner.prisoner_number} - ${visit.visitor.firstname} ${visit.visitor.lastname} ${getAdditionalVisitorsTextForBookingSlot(visit.additional_visitors)}`],
              kioskItems: visit.kiosk_items || [],
            });
          } else {
            // Add to existing booking slot
            wings[wingIndex].bookingSlots[bookingSlotIndex].visitInfo.push(
              `${visit.prisoner.firstname} ${visit.prisoner.lastname} ${visit.prisoner.prisoner_number} - ${visit.visitor.firstname} ${visit.visitor.lastname} ${getAdditionalVisitorsTextForBookingSlot(visit.additional_visitors)}`,
            );
            wings[wingIndex].bookingSlots[bookingSlotIndex].kioskItems = visit.kiosk_items || [];
          }
        }
      });
      this.groupedData = wings;
    },
    getTerminalsRequiredForWing(wingIndex) {
      let terminals = 0;
      this.groupedData[wingIndex].bookingSlots.forEach(bookingSlot => {
        terminals += bookingSlot.visitInfo.length;
      });
      return terminals;
    },
  },
};
</script>
